export function calculateErrorMargins({
  errorMargin,
  min,
  max,
  correctAnswer,
}: {
  errorMargin: number;
  min: number;
  correctAnswer: number;
  max: number;
}) {
  const lowerBoundary = correctAnswer - errorMargin;
  const upperBoundary = correctAnswer + errorMargin;
  const answerIsOutsideRange = correctAnswer < min || correctAnswer > max;

  const clampedLowerBoundary = answerIsOutsideRange
    ? lowerBoundary
    : Math.max(min, lowerBoundary);
  const clampedUpperBoundary = answerIsOutsideRange
    ? upperBoundary
    : Math.min(max, upperBoundary);

  return {
    lowerBoundary: clampedLowerBoundary,
    upperBoundary: clampedUpperBoundary,
  };
}
